import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-extraneous-dependencies
import { SpacerHorizontal } from '@klarna/bubble-ui';

const styles = {
  childStyle: {
    paddingLeft: 15,
    paddingRight: 15,
    verticalAlign: 'middle',
    display: 'inline-block',
  },
  itemWithIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const FooterElement = ({ children, icon = '', style = {} }) => (
  <div style={{ ...styles.childStyle, ...style }}>
    {icon ? (
      <div style={styles.itemWithIcon}>
        {icon}
        <SpacerHorizontal small />
        {children}
      </div>
    ) : (
      children
    )}
  </div>
);

FooterElement.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  style: PropTypes.object,
};

export default FooterElement;
